import React from 'react';

import './SingleBank.scss';

import BankSnapshot from '../BankSnapshot/BankSnapshot';
import { isBuy, isCollegeContribute } from '../../../utils/transactions-util';
import { isJustAdded } from '../../../utils/utils';

export class SingleBank extends React.Component {
  UNSAFE_componentWillMount() {
    const {
      fundingSource,
      actions: { selectBank },
    } = this.props;
    //TODO: will need to update this for recurring buy as well
    if (isBuy() || isCollegeContribute()) {
      if (
        isJustAdded(fundingSource[0]) === true ||
        !fundingSource[0].bankAwaitingVerification
      ) {
        selectBank(fundingSource[0]);
      }
    } else {
      selectBank(fundingSource[0]);
    }
  }

  render() {
    const { fundingSource } = this.props;
    return (
      <div>
        <div className="e2e-chosen-bank single-bank-chosen-bank">
          CHOSEN BANK
        </div>
        <div>
          <BankSnapshot
            bank={fundingSource[0]}
            editMode={false}
            isReview
            isSingleBank
          />
        </div>
      </div>
    );
  }
}

export default SingleBank;
